// PetKings — JS propio, vanilla, sin librerías externas.

function pkInitReveal() {
  var els = document.querySelectorAll('.pk-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('pk-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pk-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--pk-delay', Math.min(i % 6, 5) * 0.08 + 's');
    io.observe(el);
  });
}

function pkInitContadores() {
  var els = document.querySelectorAll('[data-pk-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var target = parseFloat(el.getAttribute('data-pk-contador')) || 0;
      var suffix = el.getAttribute('data-pk-sufijo') || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        var val = Math.round(target * eased);
        el.textContent = val.toLocaleString('es-ES') + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { io.observe(el); });
}

function pkInitResenasCarrusel() {
  document.querySelectorAll('[data-pk-resenas]').forEach(function (wrap) {
    var track = wrap.querySelector('.pk-resenas-track');
    var prev = wrap.querySelector('[data-pk-prev]');
    var next = wrap.querySelector('[data-pk-next]');
    if (!track || !prev || !next) return;
    function scrollAmount() {
      var card = track.querySelector('.pk-resena-card');
      return card ? card.offsetWidth + 20 : 300;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });
}

function pkInitGaleriaProducto() {
  document.querySelectorAll('[data-pk-producto-galeria]').forEach(function (wrap) {
    var principal = wrap.querySelector('[data-pk-imagen-principal]');
    var thumbs = wrap.querySelectorAll('[data-pk-thumb]');
    if (!principal || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-full');
        var alt = t.getAttribute('data-alt') || '';
        if (!src) return;
        principal.src = src;
        principal.alt = alt;
        thumbs.forEach(function (o) { o.classList.remove('pk-thumb-activo'); });
        t.classList.add('pk-thumb-activo');
      });
    });
  });
}

function pkInitVariantes() {
  document.querySelectorAll('[data-pk-form-producto]').forEach(function (form) {
    var dataEl = form.querySelector('[data-pk-variantes-json]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-pk-precio-actual]');
    var precioAntEl = form.querySelector('[data-pk-precio-anterior]');
    var botonComprar = form.querySelector('[data-pk-boton-comprar]');
    var selects = form.querySelectorAll('[data-pk-opcion]');
    if (!dataEl || !idInput) return;
    var variantes = [];
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function moneda(cents) {
      return '€' + (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function actualizar() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      var encontrada = variantes.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === valores[idx]; });
      });
      if (!encontrada) return;
      idInput.value = encontrada.id;
      if (precioEl) precioEl.textContent = moneda(encontrada.price);
      if (precioAntEl) {
        if (encontrada.compare_at_price && encontrada.compare_at_price > encontrada.price) {
          precioAntEl.textContent = moneda(encontrada.compare_at_price);
          precioAntEl.style.display = '';
        } else {
          precioAntEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !encontrada.available;
        botonComprar.textContent = encontrada.available
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function pkInitBeneficiosSlider() {
  document.querySelectorAll('[data-pk-beneficios-slider]').forEach(function (wrap) {
    var imgs = wrap.querySelectorAll('[data-pk-slide-img]');
    var textos = wrap.querySelectorAll('[data-pk-slide-texto]');
    var dots = wrap.querySelectorAll('[data-pk-dot]');
    if (!imgs.length) return;
    var total = imgs.length;
    var actual = 0;
    var velocidad = parseInt(wrap.getAttribute('data-velocidad'), 10) || 4000;
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    function irA(index) {
      actual = (index + total) % total;
      imgs.forEach(function (el) { el.classList.toggle('pk-activa', parseInt(el.getAttribute('data-index'), 10) === actual); });
      textos.forEach(function (el) { el.classList.toggle('pk-activa', parseInt(el.getAttribute('data-index'), 10) === actual); });
      dots.forEach(function (el) { el.classList.toggle('pk-activa', parseInt(el.getAttribute('data-index'), 10) === actual); });
    }

    function siguiente() { irA(actual + 1); }

    function iniciar() {
      if (reducido || total < 2) return;
      detener();
      timer = setInterval(siguiente, velocidad);
    }
    function detener() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        irA(parseInt(dot.getAttribute('data-index'), 10));
        iniciar();
      });
    });

    wrap.addEventListener('mouseenter', detener);
    wrap.addEventListener('mouseleave', iniciar);

    iniciar();
  });
}

function pkInitPacks() {
  document.querySelectorAll('[data-pk-pack-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var boton = form.querySelector('[data-pk-pack-boton]');
      var variantId = form.querySelector('input[name="id"]').value;
      if (!variantId || (boton && boton.disabled)) return;
      var textoOriginal = boton ? boton.textContent : '';
      if (boton) { boton.disabled = true; boton.textContent = 'Añadiendo…'; }
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_add_url ? window.Shopify.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart'; })
        .catch(function () {
          if (boton) { boton.disabled = false; boton.textContent = textoOriginal; }
        });
    });
  });
}

function pkInitTiltCards() {
  var cards = document.querySelectorAll('.pk-beneficio-card, .pk-paso-media');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(700px) rotateY(' + (x * 4) + 'deg) rotateX(' + (y * -4) + 'deg)';
    });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  pkInitReveal();
  pkInitContadores();
  pkInitResenasCarrusel();
  pkInitGaleriaProducto();
  pkInitVariantes();
  pkInitBeneficiosSlider();
  pkInitPacks();
  pkInitTiltCards();
});
